import React, { createContext, useContext, useEffect, useState } from "react";
import { startAutoTranslate } from "./AutoTranslate";

const translations = {
  en: {
    dir: "ltr",
    name: "English",
    nav_home: "Home", nav_about: "About Us", nav_programs: "Our Programs", nav_impact: "Impact",
    nav_islamic: "Islamic Giving", nav_csr: "CSR & Partnerships", nav_technology: "Technology",
    nav_resources: "Resources", nav_contact: "Contact", nav_transparency: "Transparency",
    cta_support: "Support an Initiative", cta_explore: "Explore Our Programs",
    cta_partner: "Partner With Us", cta_learn: "Learn More", cta_zakat: "Calculate Zakat",
    cta_support_this: "Support This Initiative", cta_get_involved: "Get Involved",
    hero_title_1: "Technology for Impact.", hero_title_2: "Partnerships for Change.",
    hero_sub: "Helping Hands brings technology, responsible CSR and trusted partnerships together to support initiatives that create meaningful and measurable social impact.",
    trust_line: "Responsible • Transparent • Technology Enabled",
    building_impact: "Building Impact Together",
    focus_title: "Our Focus Areas", focus_explore: "Explore Program",
    featured_title: "Featured CSR Initiatives",
    how_title: "How It Works",
    admin_login: "Admin Login", sign_out: "Sign Out",
    footer_tagline: "Technology for Impact. Partnerships for Change.",
    lang_label: "Language",
  },
  ar: {
    dir: "rtl", name: "العربية",
    nav_home: "الرئيسية", nav_about: "من نحن", nav_programs: "برامجنا", nav_impact: "الأثر",
    nav_islamic: "العطاء الإسلامي", nav_csr: "المسؤولية والشراكات", nav_technology: "التقنية",
    nav_resources: "الموارد", nav_contact: "اتصل بنا", nav_transparency: "الشفافية",
    cta_support: "ادعم مبادرة", cta_explore: "استكشف برامجنا",
    cta_partner: "كن شريكاً", cta_learn: "اعرف المزيد", cta_zakat: "احسب الزكاة",
    cta_support_this: "ادعم هذه المبادرة", cta_get_involved: "شارك معنا",
    hero_title_1: "التقنية من أجل الأثر.", hero_title_2: "الشراكات من أجل التغيير.",
    hero_sub: "تجمع يد العون بين التقنية والمسؤولية المجتمعية والشراكات الموثوقة لدعم مبادرات تُحدث أثراً اجتماعياً حقيقياً وقابلاً للقياس.",
    trust_line: "مسؤول • شفاف • مدعوم بالتقنية",
    building_impact: "نبني الأثر معاً",
    focus_title: "مجالات تركيزنا", focus_explore: "استكشف البرنامج",
    featured_title: "مبادرات مميزة", how_title: "كيف نعمل",
    admin_login: "دخول المشرف", sign_out: "تسجيل الخروج",
    footer_tagline: "التقنية من أجل الأثر. الشراكات من أجل التغيير.",
    lang_label: "اللغة",
  },
  ur: {
    dir: "rtl", name: "اردو",
    nav_home: "ہوم", nav_about: "ہمارے بارے میں", nav_programs: "ہمارے پروگرام", nav_impact: "اثر",
    nav_islamic: "اسلامی عطیات", nav_csr: "سی ایس آر و شراکت", nav_technology: "ٹیکنالوجی",
    nav_resources: "وسائل", nav_contact: "رابطہ", nav_transparency: "شفافیت",
    cta_support: "ایک اقدام کی حمایت کریں", cta_explore: "ہمارے پروگرام دیکھیں",
    cta_partner: "ہمارے شراکت دار بنیں", cta_learn: "مزید جانیں", cta_zakat: "زکوٰۃ کیلکولیٹر",
    cta_support_this: "اس اقدام کی حمایت کریں", cta_get_involved: "شامل ہوں",
    hero_title_1: "اثر کے لیے ٹیکنالوجی۔", hero_title_2: "تبدیلی کے لیے شراکت۔",
    hero_sub: "ہیلپنگ ہینڈز ٹیکنالوجی، ذمہ دار سی ایس آر اور قابلِ اعتماد شراکت داری کو یکجا کرتا ہے تاکہ بامعنی سماجی اثر پیدا کرنے والے اقدامات کی حمایت کی جا سکے۔",
    trust_line: "ذمہ دار • شفاف • ٹیکنالوجی سے آراستہ",
    building_impact: "مل کر اثر بنا رہے ہیں",
    focus_title: "ہمارے فوکس ایریاز", focus_explore: "پروگرام دیکھیں",
    featured_title: "نمایاں اقدامات", how_title: "یہ کیسے کام کرتا ہے",
    admin_login: "ایڈمن لاگ ان", sign_out: "سائن آؤٹ",
    footer_tagline: "اثر کے لیے ٹیکنالوجی۔ تبدیلی کے لیے شراکت۔",
    lang_label: "زبان",
  },
  hi: {
    dir: "ltr", name: "हिन्दी",
    nav_home: "होम", nav_about: "हमारे बारे में", nav_programs: "हमारे कार्यक्रम", nav_impact: "प्रभाव",
    nav_islamic: "इस्लामिक दान", nav_csr: "सीएसआर और साझेदारी", nav_technology: "तकनीक",
    nav_resources: "संसाधन", nav_contact: "संपर्क", nav_transparency: "पारदर्शिता",
    cta_support: "एक पहल का समर्थन करें", cta_explore: "हमारे कार्यक्रम देखें",
    cta_partner: "हमारे साथ जुड़ें", cta_learn: "और जानें", cta_zakat: "ज़कात कैलकुलेटर",
    cta_support_this: "इस पहल का समर्थन करें", cta_get_involved: "शामिल हों",
    hero_title_1: "प्रभाव के लिए तकनीक।", hero_title_2: "बदलाव के लिए साझेदारी।",
    hero_sub: "हेल्पिंग हैंड्स तकनीक, ज़िम्मेदार सीएसआर और विश्वसनीय साझेदारी को एक साथ लाता है ताकि सार्थक और मापने योग्य सामाजिक प्रभाव पैदा करने वाली पहलों का समर्थन किया जा सके।",
    trust_line: "ज़िम्मेदार • पारदर्शी • तकनीक-सक्षम",
    building_impact: "मिलकर प्रभाव बना रहे हैं",
    focus_title: "हमारे फोकस क्षेत्र", focus_explore: "कार्यक्रम देखें",
    featured_title: "प्रमुख पहलें", how_title: "यह कैसे काम करता है",
    admin_login: "एडमिन लॉगिन", sign_out: "साइन आउट",
    footer_tagline: "प्रभाव के लिए तकनीक। बदलाव के लिए साझेदारी।",
    lang_label: "भाषा",
  },
};

export const LANGS = [
  { code: "en", label: "EN", name: "English" },
  { code: "ar", label: "العربية", name: "العربية" },
  { code: "ur", label: "اردو", name: "اردو" },
  { code: "hi", label: "हिन्दी", name: "हिन्दी" },
];

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("hh_lang") || "en");

  useEffect(() => {
    const dir = translations[lang]?.dir || "ltr";
    document.documentElement.dir = dir;
    document.documentElement.lang = lang;
    if (lang !== "en") startAutoTranslate(lang);
  }, []); // run once on mount for the persisted language

  const setLang = (code) => {
    if (code === lang) return;
    localStorage.setItem("hh_lang", code);
    // Reload so auto-translation always runs from a clean English DOM.
    window.location.reload();
  };

  const t = (key) => translations[lang]?.[key] || translations.en[key] || key;
  const dir = translations[lang]?.dir || "ltr";

  return (
    <I18nContext.Provider value={{ lang, setLang, setLangState, t, dir }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
